import {useEffect, useState} from "react";

export function createHostNameXmlLinksIntegrationInitialState(projectIntegration) {
    return {
        'hostNameAndXmlLinkList': projectIntegration === null ? [{hostName: '', xmlLink: ''}] : [],
        'refundedOrderStatuses': projectIntegration?.refundedOrderStatuses ?? [],
        'unpaidOrderStatuses': projectIntegration?.unpaidOrderStatuses ?? [],
        'completedOrderStatuses': projectIntegration?.completedOrderStatuses ?? [],
    };
}

export default function useHostNameXmlLinksIntegrationState(projectIntegration) {
    let [
        projectHostNameXmlLinksIntegrationState,
        setProjectHostNameXmlLinksIntegrationState,
    ] = useState(() => createHostNameXmlLinksIntegrationInitialState(projectIntegration));

    return [
        projectHostNameXmlLinksIntegrationState,
        setProjectHostNameXmlLinksIntegrationState,
    ];
}
